export default {
  ENTER: 13,
  ESCAPE: 27,
  TAB: 9,
};
